<script>
  // Перенос Toggle из lib/ui.tsx — переключатель вкл/выкл.
  export let on = false;
  export let onChange = () => {};
</script>

<div class={'ui-toggle' + (on ? ' on' : '')} role="switch" aria-checked={on} on:click={() => onChange(!on)}>
  <div class="knob"></div>
</div>
